import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const AddDpto2 = ({styles, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Departamento nuevo
      </button>
        <div style={styles.box}>
          <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codigoDpto" id="codigoDpto" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoDpto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrDpto" id="descrDpto" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrDpto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={styles.label}>Código departamento DANE</label>
                    <Form.Input autoComplete="off" name="codigoDptoDANE" id="codigoDptoDANE" onChange={handleChange} placeholder='Código departamento DANE' icon={!errors.length?null: _find(errors, {path:'codigoDptoDANE'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>

                  <Button type='submit' primary fluid>
                    Agregar
                  </Button>

                  {
                    errors.length?<Message negative header="Los siguientes errores:"
                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
    </div>
  )
}

export default AddDpto2
